/**
 * 税码通 brand icon — barcode (码) + emerald scan line (通)
 * Scales cleanly from 18px (sidebar) to 48px (auth pages).
 * Uses a static gradient ID — safe since only one icon is visible at a time per page.
 */
export default function LogoIcon({ size = 36 }: { size?: number }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="税码通"
        >
            <defs>
                <linearGradient id="smt-bg" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#6366f1" />
                    <stop offset="1" stopColor="#7c3aed" />
                </linearGradient>
            </defs>
            <rect width="40" height="40" rx="9" fill="url(#smt-bg)" />
            {/* Barcode bars — 码 */}
            <rect x="5"  y="9" width="4"  height="19" rx="2"   fill="white" fillOpacity="0.90" />
            <rect x="15" y="9" width="10" height="19" rx="2.5" fill="white" fillOpacity="0.95" />
            <rect x="31" y="9" width="4"  height="19" rx="2"   fill="white" fillOpacity="0.90" />
            {/* Scan line — 通 */}
            <rect x="4" y="31" width="32" height="3" rx="1.5" fill="#34d399" />
        </svg>
    );
}
